import { Component, OnInit } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import {
  SearchCountryField,
  CountryISO,
  PhoneNumberFormat,
} from "ngx-intl-tel-input";

import { ContactService } from "src/app/Services/Client/contact.service";

@Component({
  selector: "app-contact-v2",
  templateUrl: "./contact-v2.component.html",
  styleUrls: ["./contact-v2.component.scss"],
})
export class ContactV2Component implements OnInit {
  constructor(public contactService: ContactService) {}
  submitted = false;
  separateDialCode = true;
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  PhoneNumberFormat = PhoneNumberFormat;
  preferredCountries: CountryISO[] = [
    CountryISO.UnitedArabEmirates,
    CountryISO.SaudiArabia,
    CountryISO.Kuwait,
    CountryISO.Bahrain,
    CountryISO.Qatar,
    CountryISO.Oman,
    CountryISO.Jordan,
    CountryISO.Egypt,
  ];
  contactForm = new FormGroup({
    phone: new FormControl(undefined, [
      Validators.required,
      Validators.minLength(8),
      Validators.maxLength(15),
      // Validators.pattern("^[0-9]*$"),
    ]),
    name: new FormControl(undefined, [
      Validators.required,
      Validators.minLength(2),
      Validators.maxLength(30),
      Validators.pattern("^[a-zA-Z ]*$"),
    ]),
    email: new FormControl(undefined, [Validators.required, Validators.email]),
  });

  onSubmit() {
    const contactData = {
      name: this.contactForm.value.name,
      email: this.contactForm.value.email,
      phone: this.contactForm.value.phone.e164Number,
    };

    this.contactService.submit(contactData).subscribe((res) => {
      if (res) {
        this.submitted = true;
      }
    });
  }

  ngOnInit(): void {}
}
